import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { ProcedureParamsListActionsProps } from './props';
import { useProcedureParamsListActions } from './hook';

export const ProcedureParamsListActions = ({
    id,
}: ProcedureParamsListActionsProps) => {
    const { handleEdit } = useProcedureParamsListActions(id);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
